const Vr11 = () => {
    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-11/PNG%20n.2/3d%20%2011-2/publish%2011-2/`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 11 Tour"
        ></iframe>
      </div>
    );
};

export default Vr11;
